module.exports = "<div *ngIf='message' class='with-errors messageBottom'>\r\n  <span>{{message}}</span>\r\n</div>"